import { render, staticRenderFns } from "./formRequest.vue?vue&type=template&id=b32f8986&scoped=true"
import script from "./formRequest.vue?vue&type=script&lang=js"
export * from "./formRequest.vue?vue&type=script&lang=js"
import style0 from "./formRequest.vue?vue&type=style&index=0&id=b32f8986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32f8986",
  null
  
)

export default component.exports